import { render } from "./CookDishCardComponent.vue?vue&type=template&id=a57d2804"
import script from "./CookDishCardComponent.vue?vue&type=script&lang=js"
export * from "./CookDishCardComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__